import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./EmployeeLogin.css";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Consultantlogin,
  verifyConsultantOtp,
} from "../../services/authService";
import { getCaptcha } from "../../services/toolkitService";
import LoginBg from "../../asseets/Loginbg.svg";
import NormalAlert from "../AlertComponent/NormalAlert";

const ConsultantLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [IsPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [otpInput, setOtpInput] = useState("");

  // Captcha states
  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [hexColor, setHexColor] = useState("#6DB0FC");

  const generateCaptcha = async () => {
    try {
      setCaptchaImage(null);
      const color = hexColor?.startsWith("#")
        ? hexColor
        : `#${hexColor || "6DB0FC"}`;
      const data = await getCaptcha(color);

      if (data && data.captchaImage) {
        setHexColor(data.hexColor);
        setCaptchaText(data.captchaText);
        setCaptchaImage(data.captchaImage);
      } else {
        console.error("Captcha API returned invalid data:", data);
        setCaptchaText("Error loading captcha");
      }
    } catch (error) {
      console.error("Captcha Error:", error);
      setCaptchaText("Error loading captcha");
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  // Login
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const validationErrors = {};
    if (!email.trim()) validationErrors.email = "Email is required.";
    if (!password.trim()) validationErrors.password = "Password is required.";
    if (!captchaInput.trim())
      validationErrors.captchaInput = "Captcha is required.";
    else if (captchaInput.trim() !== captchaText.trim()) {
      validationErrors.captchaInput =
        "Invalid captcha. Please enter the exact characters (case-sensitive).";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await Consultantlogin(email, password);
      const data = response.data;

      if (data.status === "Success" && data.authUID) {
        Cookies.set("consultantAuthUID", data.authUID, { expires: 1 / 48 });
        setIsOtpStep(true);
        setAlert({
          type: "success",
          message: "OTP sent to your email. Please verify it.",
        });
      } else {
        setAlert({ type: "fail", message: data.message || "Login failed." });
        generateCaptcha();
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message: error.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const authUID = Cookies.get("consultantAuthUID");

    if (!otpInput.trim()) {
      setAlert({ type: "fail", message: "Please enter OTP." });
      return;
    }

    try {
      const response = await verifyConsultantOtp(otpInput.trim(), authUID);
      const data = response.data;

      if (data.status === "Success" && data.userDetails?.token) {
        const { token } = data.userDetails;
        Cookies.set("ConsultantToken", token);
        Cookies.set("username", email.split("@")[0]);

        setAlert({ type: "success", message: "OTP verified successfully!" });
        setTimeout(() => navigate("/Consultant/Dashboard"), 1500);
      } else {
        setAlert({
          type: "fail",
          message: data.message || "Invalid OTP. Please try again.",
        });
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message:
          error.response?.data?.message || "Invalid OTP or expired session.",
      });
    }
  };

  return (
    <>
      <div className="login-page">
        <div className="row container-fluid m-0 p-0 vh-100">
          {/* Left side (form) */}
          <div className="col-12 col-md-6 p-5 rounded-1 animate-fade d-flex flex-column justify-content-center">
            <div className="text-center">
              <Link to={"/"}>
                <img
                  src="/HRSetu-final-logo.svg"
                  alt="..HR-SETU-Logo"
                  width={100}
                />
              </Link>

              <h4 className="text-center mt-5 animate-slide-in text-dark">
                {isOtpStep
                  ? "Enter OTP to Verify"
                  : "Login to your Consultant account"}
              </h4>
              <p className="text-muted">
                {isOtpStep
                  ? "Please enter the OTP sent to your registered email."
                  : "Welcome back, please enter your details"}
              </p>
            </div>

            {!isOtpStep ? (
              <form className="animate-form px-5 py-4">
                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label text-dark">
                    Email address
                  </label>
                  <div className="position-relative">
                    <span className="InputLogoSet mt-2">
                      <i className="bi bi-envelope-open"></i>
                    </span>
                    <input
                      type="email"
                      id="email"
                      className={`form-control rounded-3 ps-5 ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>
                </div>

                {/* Password */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label text-dark">
                    Password
                  </label>
                  <div className="position-relative">
                    <span className="InputLogoSet mt-2">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type={IsPasswordVisible ? "text" : "password"}
                      id="password"
                      className={`form-control rounded-3 ps-5 ${
                        errors.password ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                    />
                    <a
                      className="text-dark eyeBtnSet"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsPasswordVisible(!IsPasswordVisible);
                      }}
                    >
                      {IsPasswordVisible ? (
                        <i className="bi bi-eye-slash"></i>
                      ) : (
                        <i className="bi bi-eye"></i>
                      )}
                    </a>
                    {errors.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>
                </div>

                {/* Captcha */}
                <div className="mb-3">
                  <label className="form-label text-dark">
                    Verification Code
                  </label>

                  <div className="d-flex align-items-center">
                    {/* Captcha Image Container */}
                    <div
                      className="me-2 d-flex align-items-center justify-content-center"
                      style={{ width: "150px", height: "45px" }}
                    >
                      {/* Case 1: Spinner during loading or refresh */}
                      {captchaImage === null ||
                      (!captchaImage && !captchaText) ? (
                        <div
                          className="d-flex justify-content-center align-items-center w-100 h-100 border rounded"
                          style={{ background: "#f2f2f2" }}
                        >
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                          />
                        </div>
                      ) : captchaImage ? (
                        // Case 2: Captcha image loaded successfully
                        <img
                          key={captchaImage} // forces re-render when refreshed
                          src={captchaImage}
                          alt="Captcha"
                          style={{
                            width: "150px",
                            height: "45px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        // Case 3: Fallback (if text-based captcha available)
                        <div
                          style={{
                            background: "#f2f2f2",
                            padding: "10px 20px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            userSelect: "none",
                            width: "150px",
                            height: "45px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                          }}
                        >
                          {captchaText || (
                            <div
                              className="spinner-border spinner-border-sm text-primary"
                              role="status"
                            />
                          )}
                        </div>
                      )}
                    </div>

                    {/* Refresh button */}
                    <button
                      type="button"
                      className="btn btn-link ms-2"
                      onClick={generateCaptcha}
                      disabled={loading}
                      style={{ color: "#004687" }}
                      title="Refresh Captcha"
                    >
                      <i className="bi bi-arrow-clockwise fs-5"></i>
                    </button>

                    {/* Captcha Input */}
                    <div className="w-75">
                      <input
                        type="text"
                        className={`form-control mt-2 ${
                          errors.captchaInput ? "is-invalid" : ""
                        }`}
                        placeholder="Enter Verification Code"
                        value={captchaInput}
                        onChange={(e) => setCaptchaInput(e.target.value)}
                        disabled={loading}
                      />
                      {errors.captchaInput && (
                        <div className="invalid-feedback">
                          {errors.captchaInput}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Login Button */}
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn custom-btn mt-2"
                    onClick={handleLogin}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Logging in...
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>
              </form>
            ) : (
              // OTP Step
              <form
                className="animate-form px-5 py-4"
                onSubmit={handleVerifyOtp}
              >
                <div className="mb-3">
                  <label className="form-label text-dark">Enter OTP</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    placeholder="Enter 6-digit OTP"
                    value={otpInput}
                    onChange={(e) => setOtpInput(e.target.value)}
                  />
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn custom-btn">
                    Verify OTP
                  </button>
                </div>
              </form>
            )}
          </div>

          {/* Right side (image) */}
          <div className="col-12 col-md-6 text-center p-0 d-md-block d-none">
            <img src={LoginBg} alt="..login" className="login-image" />
          </div>
        </div>
      </div>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default ConsultantLogin;
